import React from 'react';
import { animated, useSpring } from '@react-spring/web';
import './action.scss';

export const Flexbox = ({ children, justifyContent = '', alignItems = '', gap = '', style = {}, className = '', flexDirection = '', fw, ...props }) => {
  const flexStyle = {
    justifyContent,
    alignItems,
    gap,
    flexDirection,
    width: fw ? '100%' : '',
    ...style,
  };

  return (
    <animated.div className={`flexbox ${className}`} style={flexStyle} {...props}  >
      {children}
    </animated.div>
  );
};

export const FlexboxColumn = ({ flexDirection = 'column', justifyContent, alignItems, ...args }) => {
  return <Flexbox flexDirection={flexDirection} justifyContent={justifyContent} alignItems={alignItems} {...args}  />;
};
